export default "__VITE_PUBLIC_ASSET__1dc922f4__"